import React, { useState, useEffect } from 'react';
import { X, Sparkles, Filter, MessageCircle, Zap, Bell } from 'lucide-react';

const UpdateNotification = () => {
  const [show, setShow] = useState(false);
  const currentVersion = '2.8';

  useEffect(() => {
    // Verificar se o usuário já viu esta versão
    const lastSeenVersion = localStorage.getItem('stakemind_last_seen_version');
    
    if (lastSeenVersion !== currentVersion) {
      // Mostrar o banner após 2 segundos do login
      const timer = setTimeout(() => {
        setShow(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    // Marcar esta versão como vista
    localStorage.setItem('stakemind_last_seen_version', currentVersion);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-start justify-center pt-4 sm:pt-20 px-4 animate-fade-in">
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-900 rounded-2xl shadow-2xl max-w-2xl w-full border-2 border-blue-200 dark:border-blue-800 animate-slide-down overflow-hidden">
        {/* Header com gradiente */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 opacity-20">
            <Sparkles className="w-32 h-32" />
          </div>
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-lg transition-colors z-10"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
          
          <div className="flex items-center space-x-3 mb-2 relative z-10">
            <div className="bg-white/20 p-2 rounded-lg">
              <Bell className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-2xl font-bold">🎯 NOVIDADES STAKE MIND</h2>
              <p className="text-blue-100">Versão 2.8 - Melhorias Importantes</p>
            </div>
          </div>
        </div>

        {/* Conteúdo */}
        <div className="p-6 space-y-5 max-h-[60vh] overflow-y-auto">
          
          {/* Filtros de Período em Grupos */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 border-l-4 border-blue-500 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start space-x-3">
              <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-lg">
                <Filter className="w-6 h-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 dark:text-white mb-2">
                  📊 FILTROS DE PERÍODO EM GRUPOS
                </h3>
                <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                  <li>✅ Agora você pode filtrar seus grupos por período!</li>
                  <li>• Mês Atual / Mês Anterior</li>
                  <li>• Últimos 3 Meses / Todo o Período</li>
                  <li>• Período Personalizado</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Suporte WhatsApp */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 border-l-4 border-green-500 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start space-x-3">
              <div className="bg-green-100 dark:bg-green-900/30 p-2 rounded-lg">
                <MessageCircle className="w-6 h-6 text-green-600 dark:text-green-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 dark:text-white mb-2">
                  📱 SUPORTE SEMPRE À MÃO
                </h3>
                <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                  <li>✅ Botão de WhatsApp no menu lateral</li>
                  <li>✅ Número de suporte na página inicial</li>
                  <li>• Acesso rápido: (11) 91656-0595</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Melhorias de Performance */}
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4 border-l-4 border-purple-500 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start space-x-3">
              <div className="bg-purple-100 dark:bg-purple-900/30 p-2 rounded-lg">
                <Zap className="w-6 h-6 text-purple-600 dark:text-purple-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 dark:text-white mb-2">
                  🔧 MELHORIAS DE PERFORMANCE
                </h3>
                <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                  <li>✅ Login mais rápido e estável</li>
                  <li>✅ Interface mais responsiva</li>
                  <li>✅ Correções de bugs críticos</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Footer inspiracional */}
          <div className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl p-4 text-white text-center">
            <p className="font-semibold text-lg">
              ✨ Versão 2.8 Disponível Agora!
            </p>
            <p className="text-sm text-blue-100 mt-1">
              Continue profissionalizando suas apostas com o Stake Mind!
            </p>
          </div>
        </div>

        {/* Botão de ação */}
        <div className="p-6 bg-gray-50 dark:bg-gray-800/50 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg"
          >
            Entendi! Vamos testar 🚀
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
